import Select from '../Select';

const SelectResourceType = ({ value, onChange }) => {
    return (
        <Select
            id="type"
            label={'Type'}
            onChange={onChange}
            value={value}
            inputClassName="w-full"
            options={{
                '': 'Choose type...',
                Spot: 'Spot',
                Bay: 'Bay',
                Cage: 'Cage',
                Chair: 'Chair',
                Court: 'Court',
                House: 'House',
                Lane: 'Lane',
                Room: 'Room',
                Seat: 'Seat',
            }}
        />
    );
};

export default SelectResourceType;
